import script from "./CandidateStatistic.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandidateStatistic.vue?vue&type=script&setup=true&lang=ts"

import "./CandidateStatistic.vue?vue&type=style&index=0&id=09720a88&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09720a88"]])

export default __exports__